// extracted by mini-css-extract-plugin
export default {"heading":"Ru-z","corrected":"Su-z","redirectVerbiageContainer":"Tu-z","redirectVerbiageText":"Uu-z"};